import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  badgeContent: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: "16px",
    padding: "8px 12px",
    height: "32px",
    borderRadius: "100px",
    whiteSpace: "nowrap",
    width: "fit-content",
  },
}));

export default styles;
